import {
  Card,
  CardHeader,
  CardBody,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Flex,
  Input,
} from "@chakra-ui/react";
import { BrlCurrencyFormatter } from "@/utils/BrlCurrencyFormatter";
import { formatDateWithNoHours } from "@/utils/formatDateWithNoHours";
import { PropostaFinanceira } from "@/models/consignado/propostaFinanceira.model";

export interface InsuranceDataCardProps {
  proposal: PropostaFinanceira;
  editedValues: {
    dataPagamentoSeguro: string;
    quantidadeParcelaSeguro: number;
    valorLiberadoSeguro: number;
  };
  editingFields: {
    dataPagamentoSeguro: boolean;
    quantidadeParcelaSeguro: boolean;
    valorLiberadoSeguro: boolean;
  };
  monetaryInputs: {
    valorLiberadoSeguro: string;
  };
  onChangeField: (field: "dataPagamentoSeguro" | "quantidadeParcelaSeguro" | "valorLiberadoSeguro", value: string) => void;
}

const formatDateToInputValue = (value: string): string => {
  if (!value)
    return "";

  const date = new Date(value);

  if (!Number.isNaN(date.getTime()))
    return date.toISOString().slice(0, 10);

  return value.split(" ")[0] || "";
};

export default function InsuranceDataCard({
  proposal,
  editedValues,
  editingFields,
  monetaryInputs,
  onChangeField,
}: InsuranceDataCardProps) {
  return (
    <Card p={6} bg="white" borderRadius="lg" shadow="sm" borderWidth="2px" borderColor="gray.200">
      <CardHeader p={0} mb={6}>
        <Text fontSize="md" fontWeight="bold" color="gray.700">
          DADOS SEGURADORA
        </Text>
      </CardHeader>
      <CardBody p={0}>
        {!proposal.insuranceCompanyId && !proposal.insuranceCompanyName && (
          <Flex alignItems="center" justifyContent="center" py={10}>
            <Text fontSize="sm" color="gray.500">
              Proposta realizada sem seguro.
            </Text>
          </Flex>
        )}
        {proposal.insuranceCompanyId && proposal.insuranceCompanyName && (
          <TableContainer>
          <Table variant="simple" size="sm">
            <Thead>
              <Tr>
                <Th fontSize="xs" color="gray.500" textTransform="uppercase">
                  <Flex alignItems="center" justifyContent="space-between" gap={2}>
                    Valor Granatech
                    {/* <IconButton
                      aria-label="editar-valorLiberadoSeguro"
                      icon={<EditIcon />}
                      size="xs"
                      variant="ghost"
                      onClick={() => onToggleField("valorLiberadoSeguro")}
                    /> */}
                  </Flex>
                </Th>
                <Th fontSize="xs" color="gray.500" textTransform="uppercase">
                  <Flex alignItems="center" justifyContent="space-between" gap={2}>
                    Data Granatech
                    {/* <IconButton
                      aria-label="editar-dataPagamentoSeguro"
                      icon={<EditIcon />}
                      size="xs"
                      variant="ghost"
                      onClick={() => onToggleField("dataPagamentoSeguro")}
                    /> */}
                  </Flex>
                </Th>
                {/* <Th fontSize="xs" color="gray.500" textTransform="uppercase">
                  Valor Hub4Pay
                </Th> */}
                {/* <Th fontSize="xs" color="gray.500" textTransform="uppercase">
                  Data Hub4Pay
                </Th> */}
                <Th fontSize="xs" color="gray.500" textTransform="uppercase" isNumeric>
                  <Flex alignItems="center" justifyContent="space-between" gap={2}>
                    Parcelas
                    {/* <IconButton
                      aria-label="editar-quantidadeParcelaSeguro"
                      icon={<EditIcon />}
                      size="xs"
                      variant="ghost"
                      onClick={() => onToggleField("quantidadeParcelaSeguro")}
                    /> */}
                  </Flex>
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr key={proposal.id}>
                <Td color="gray.800">
                  {editingFields.valorLiberadoSeguro
                    ? (
                      <Input
                        size="sm"
                        type="text"
                        inputMode="numeric"
                        value={monetaryInputs.valorLiberadoSeguro}
                        onChange={(event) => onChangeField("valorLiberadoSeguro", event.target.value)}
                      />
                    )
                    : BrlCurrencyFormatter(editedValues.valorLiberadoSeguro)}
                </Td>
                <Td color="gray.700">
                  {editingFields.dataPagamentoSeguro
                    ? (
                      <Input
                        size="sm"
                        type="date"
                        value={formatDateToInputValue(editedValues.dataPagamentoSeguro)}
                        onChange={(event) => onChangeField("dataPagamentoSeguro", event.target.value)}
                      />
                    )
                    : formatDateWithNoHours(editedValues.dataPagamentoSeguro)}
                </Td>
                {/* <Td color="gray.800">{BrlCurrencyFormatter(proposal.valor_pago_hub4pay)}</Td> */}
                {/* <Td color="gray.700">{formatDateWithNoHours(proposal.data_pagamento_hub4pay)}</Td> */}
                <Td isNumeric color="gray.800">
                  {editingFields.quantidadeParcelaSeguro
                    ? (
                      <Input
                        size="sm"
                        type="number"
                        value={String(editedValues.quantidadeParcelaSeguro ?? "")}
                        onChange={(event) => onChangeField("quantidadeParcelaSeguro", event.target.value)}
                      />
                    )
                    : editedValues.quantidadeParcelaSeguro}
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
        )} 
      </CardBody>
    </Card>
  );
}

